import { ExportScheduleForm } from '@modules/jupiter/home/@components/export-scheduling-management/export-schedule.types';

export namespace ExportScheduleActions {
  export class List {
    static readonly type = '[Jupiter] List Export Schedules';
  }

  export class SetList {
    static readonly type = '[Jupiter] Set Export Schedules';

    constructor(public scheduledExports: ExportScheduleForm[]) {}
  }

  export class SetActive {
    static readonly type = '[Jupiter] Set Active Export Schedule';

    constructor(public id: number | null) {}
  }

  export class Reset {
    static readonly type = '[Jupiter] Reset Export Schedules';
  }

  export class Create {
    static readonly type = '[Jupiter] Create Export Schedule';

    constructor(public schedule: ExportScheduleForm) {}
  }

  export class Update {
    static readonly type = '[Jupiter] Update Export Schedule';

    constructor(public schedule: ExportScheduleForm) {}
  }

  export class Delete {
    static readonly type = '[Jupiter] Delete Export Schedule';

    constructor(public id: number) {}
  }
}
